import { lazy } from 'react';

export const AddProfile = lazy(() => import('./AddProfile.tsx').then((module) => ({ default: module.AddProfile })));

export const CastCrew = lazy(() =>
    import('../../features/detail-overlay/components/CastCrew.tsx').then((module) => ({ default: module.CastCrew }))
);

export const ChannelsCarousel = lazy(() =>
    import('./ChannelsCarousel.tsx').then((module) => ({ default: module.ChannelsCarousel }))
);

export const RemindersCarousel = lazy(() =>
    import('./RemindersCarousel.tsx').then((module) => ({ default: module.RemindersCarousel }))
);

export const EditProfile = lazy(() => import('./EditProfile.tsx').then((module) => ({ default: module.EditProfile })));

export const FullVODCatalogList = lazy(() =>
    import('./FullVODCatalogList.tsx').then((module) => ({ default: module.FullVODCatalogList }))
);
export const GenresCarousel = lazy(() =>
    import('./GenresCarousel.tsx').then((module) => ({ default: module.GenresCarousel }))
);

export const BSAddonsBanner = lazy(() =>
    import('./BSAddonsBanner.tsx').then((module) => ({ default: module.BSAddonsBanner }))
);

export const ImagesCarousel = lazy(() =>
    import('./ImagesCarousel.tsx').then((module) => ({ default: module.ImagesCarousel }))
);
export const ParentalPinManagementForm = lazy(() =>
    import('./ParentalPinManagementForm.tsx').then((module) => ({ default: module.ParentalPinManagementForm }))
);
export const ProfileSettings = lazy(() =>
    import('./ProfileSettings.tsx').then((module) => ({ default: module.ProfileSettings }))
);
export const ProfileHistory = lazy(() =>
    import('./ProfileHistory.tsx').then((module) => ({ default: module.ProfileHistory }))
);
export const Providers = lazy(() => import('./Providers.tsx').then((module) => ({ default: module.Providers })));
export const ProvidersGrid = lazy(() =>
    import('./ProvidersGrid.tsx').then((module) => ({ default: module.ProvidersGrid }))
);
export const RewindCarousel = lazy(() =>
    import('./RewindCarousel.tsx').then((module) => ({ default: module.RewindCarousel }))
);
export const SearchResults = lazy(() =>
    import('./SearchResults.jsx').then((module) => ({ default: module.SearchResults }))
);

export const SelectProfile = lazy(() =>
    import('./SelectProfile.tsx').then((module) => ({ default: module.SelectProfile }))
);
export const StreamingCarousel = lazy(() =>
    import('./StreamingCarousel.tsx').then((module) => ({ default: module.StreamingCarousel }))
);
export const TvGuideCarousel = lazy(() =>
    import('./TvGuideCarousel.tsx').then((module) => ({ default: module.TvGuideCarousel }))
);
export const UserDevices = lazy(() => import('./UserDevices.tsx').then((module) => ({ default: module.UserDevices })));
export const UserWatchlist = lazy(() =>
    import('./UserWatchlist.tsx').then((module) => ({ default: module.UserWatchlist }))
);
export const VodCarousel = lazy(() => import('./VodCarousel.tsx').then((module) => ({ default: module.VodCarousel })));
export const VodPlayer = lazy(() => import('./VodPlayer').then((module) => ({ default: module.VodPlayer })));
export const WatchlistCarousel = lazy(() =>
    import('./WatchlistCarousel.tsx').then((module) => ({ default: module.WatchlistCarousel }))
);
export const UpgradedBanner = lazy(() =>
    import('./UpgradedBanner.tsx').then((module) => ({ default: module.UpgradedBanner }))
);

export const UpgradedBannerFail = lazy(() =>
    import('./UpgradedBannerFail.tsx').then((module) => ({ default: module.UpgradedBannerFail }))
);

export const ColdStart = lazy(() => import('./ColdStart.tsx').then((module) => ({ default: module.ColdStart })));

export const ConsentManagement = lazy(() =>
    import('./ConsentManagement.tsx').then((module) => ({ default: module.ConsentManagement }))
);

export const MoodsRecommendation = lazy(() =>
    import('./MoodsRecommendation.tsx').then((module) => ({ default: module.MoodsRecommendation }))
);

export const GamesCarousel = lazy(() =>
    import('./GamesCarousel.tsx').then((module) => ({ default: module.GamesCarousel }))
);

export const CatchUpCarousel = lazy(() =>
    import('./CatchUpCarousel.tsx').then((module) => ({ default: module.CatchUpCarousel }))
);

export const MarketingLanding = lazy(() =>
    import('./MarketingLanding.tsx').then((module) => ({ default: module.MarketingLanding }))
);
